import { NgModule } from '@angular/core';

import { DragulaModule } from 'ng2-dragula';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { DragDropModule } from '@angular/cdk/drag-drop';

const IMPORTED_MODULES: any[] =[
  CodemirrorModule,
  DragulaModule.forRoot()
]

const EXPORTED_MODULES: any[] =[
  CodemirrorModule,
  DragulaModule,
  DragDropModule
]

@NgModule({
  imports: IMPORTED_MODULES,
  exports: EXPORTED_MODULES
})
export class ThirdPartyModule { }
